import getValueReduxUtil from 'modules/redux/utils/get-value'
import { WORKOUT_KEY } from 'modules/training/models/workout/constants'

function getImageWorkoutUtil (instance) {
  return getValueReduxUtil(
    instance, WORKOUT_KEY.IMAGE
  )
}

export default getImageWorkoutUtil
